import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  ReportHeading,
  LoaderWrapper,
  ReportOuterWrapper,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { useExportToPptObjects } from '../../../../hooks/useExportToPptObjects'
import { useGlobalStore } from '../../../../store'
import ReportEditRecommendations from './reportEditRecommendations'
import { convertHtmlToPptJson } from '../../../reportsPpt/commonFunctions'
import decode from 'unescape'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import { getObjectAsArray } from '../../../../util'
import { OuterWrapper, InnerWrapper, ContentWrapper } from './style'

let count = 0
const removeTags = (str) => {
  let data = str
  const replaceArray = [
    '<STRONG>',
    '</STRONG>',
    '<strong>',
    '</strong>',
    '<STRIKE>',
    '</STRIKE>',
    '<strike>',
    '</strike>',
    '<S>',
    '</S>',
    '<s>',
    '</s>',
    '<EM>',
    '</EM>',
    '<em>',
    '</em>',
    '<SUB>',
    '</SUB>',
    '<sub>',
    '</sub>',
    '<SUP>',
    '</SUP>',
    '<sup>',
    '</sup>',
    '<UNDERLINE>',
    '</UNDERLINE>',
    '<underline>',
    '</underline>',
  ]
  if (typeof data === 'string') {
    data = str.split('<ul>')[0]
    data = data.replaceAll('<sup>TM</sup>', ' ').replaceAll('<SUP>TM</SUP>', ' ')
    for (let r = 0; r < replaceArray.length; r++) {
      data = data.replaceAll(replaceArray[r], '')
    }
    data = data
      .replaceAll('<BR />', ' ')
      .replaceAll('<br />', ' ')
      .replaceAll('<BR>', ' ')
      .replaceAll('<br>', ' ')
    data = data
      .replaceAll('&nbsp;', ' ')
      .replaceAll('&amp;', '&')
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '\/')
      .replaceAll('&apos;', "'")
    data = data
      .replace(/<\/?span[^>]*>/g, '')
      .replace(/<\/?div[^>]*>/g, '')
      .replace(/<\/?p[^>]*>/g, '')
  }
  return data
}
const nodeJsonMainFunc = async (nodes) => {
  let excelData = []
  const nodeJsonFunc = async (nodes, parentNode) => {
    let obj = {}
    if (
      parentNode === 'UL' ||
      parentNode === 'ULUL' ||
      parentNode === 'ULULUL' ||
      parentNode === 'ULULULUL'
    ) {
      obj = []
    }

    for (let i = 0; i < nodes.length; i++) {
      const loopNode = nodes[i]
      let tag = loopNode.nodeName

      if (tag === 'DIV') {
        const txt = loopNode?.childNodes[0]?.nodeValue
        if (txt?.trim().length !== 0) {
          count++
          excelData.push({ tag: tag, value: txt })
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content:
              loopNode?.childNodes?.length > 0 ? [await nodeJsonFunc(loopNode.childNodes, tag)] : [],
          }
        }
      }
      if (tag === 'UL') {
        count++
        const tagNew =
          parentNode === 'LILILI'
            ? 'ULULULUL'
            : parentNode === 'LILI'
              ? 'ULULUL'
              : parentNode === 'LI'
                ? 'ULUL'
                : tag
        obj[tag + count] = {
          tag: tagNew,
          content:
            loopNode?.childNodes?.length > 0 ? await nodeJsonFunc(loopNode.childNodes, tagNew) : [],
        }
      }
      if (tag === 'LI') {
        const txt = removeTags(loopNode.innerHTML)
        if (txt?.trim().length !== 0) {
          const tagNew =
            parentNode === 'ULULULUL'
              ? 'LILILILI'
              : parentNode === 'ULULUL'
                ? 'LILILI'
                : parentNode === 'ULUL'
                  ? 'LILI'
                  : tag
          const txtDash =
            parentNode === 'ULULULUL'
              ? '---- '
              : parentNode === 'ULULUL'
                ? '-- '
                : parentNode === 'ULUL'
                  ? ''
                  : 'DELETE'
          if (txtDash !== 'DELETE') {
            excelData.push({ tag: tag, value: txtDash + txt })
          }
          obj.push({
            tag: tagNew,
            text: txt,
            content:
              loopNode?.childNodes?.length > 1 ? await nodeJsonFunc(loopNode.childNodes, tagNew) : '',
          })
        }
      }
      if (tag === 'P') {
        const txt = removeTags(loopNode.innerHTML) + ''
        if (txt?.trim().length !== 0) {
          count++
          if (
            !(
              parentNode === 'LI' ||
              parentNode === 'LILI' ||
              parentNode === 'LILILI' ||
              parentNode === 'LILILILI'
            )
          ) {
            excelData.push({ tag: tag, value: txt })
          }
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'H4') {
        const txt = removeTags(loopNode.innerHTML) + ''
        if (txt?.trim().length !== 0) {
          count++
          if (!(parentNode === 'LILI' || parentNode === 'LILILI' || parentNode === 'LILILILI')) {
            excelData.push({ tag: 'none', value: '' })
            excelData.push({ tag: tag, value: txt })
          }
          obj[tag + count] = {
            tag: tag,
            text: txt,
            content: '',
          }
        }
      }
      if (tag === 'HR') {
        count++
        obj[tag + count] = {
          tag: '',
          text: '',
          content: '',
        }
      }
    }
    return obj
  }
  await nodeJsonFunc(nodes)
  return excelData.map((e) => {
    if (e.value === '<hr>') e.value = ''
    return e
  })
}

const ReportRecommendations = (props) => {
  const [loading, setLoading] = useState()
  const [pageData, setPageData] = useState()
  const [selectedObject, setSelectedObject] = useState()
  const { id } = useParams()
  const { user, projectIdValue, isPPTModalActive, exportToPptObject, setExportToPptObject } = useGlobalStore()
  const [htmlToJsonData, setHtmlToJsonData] = useState()
  const [docArrayData, setDocArrayData] = useState()
  const [hasTables, setHasTables] = useState(false)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { updatingExportToPptObject } = useExportToPptObjects()

  const removingTags = (str) => {
    let d1 = str
    if (isPPTModalActive) {
      const htmlNode = document.querySelectorAll(`#${props.type} *`)
      for (let i = 0; i < htmlNode.length; i++) {
        // htmlNode[i].removeAttribute('style')
      }
      const htmlStr = document
        .getElementById(props.type)
        .innerHTML.replaceAll('<ol', '<ul')
        .replaceAll('</ol>', '</ul>')
      document.getElementById(props.type).innerHTML = htmlStr
    }
    return d1
  }

  /*
    const useReactQueryObject = {
        payloadDetails: {
            queryId: [props.InsightsElementType, props.InsightsElementId],
            urlFunc: ReportsService.reportRecommendationsApi,
            payload: { insightsElementId:props.InsightsElementId }
        }
    }
    const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)
  */

  const loadReportRecommendations = (getLatest = false) => {
    setLoading(true)
    ReportsService.reportRecommendationsApi(
      { insightsElementId: props.InsightsElementId },
      getLatest
    )
      .then((resp) => {
        const respNew = Array.isArray(resp) ? resp[0] : resp
        setPageData(decode(respNew))
        setLoading(false)
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
        setLoading(false)
      })
  }

  const htmlToJson = (pageData) => {
    const data = pageData
    if (props.type && data.length > 10) {
      const rte = document.getElementById(props.type).childNodes[0].childNodes
      const jsonObj = nodeJsonMainFunc(rte)
      jsonObj.then((data) => {
        setHtmlToJsonData(data)
      })
    }
    return null
  }

  const onSuccessEdit = () => {
    loadReportRecommendations(true)
  }

  const [progressionDropdownData, setProgressionDropdownData] = useState([])
  const loadReportProlgressionDropdown = (getLatest = false) => {
    if(props.InsightsElementType !== 'RecommendationAndProgression') return

    ReportsService.reportRecommendationsProgressionApi(
      { insightsElementId: props.InsightsElementId },
      getLatest
    )
      .then((resp) => {
        const respNew = getObjectAsArray(resp).sort((a, b) => a.PeriodOrder - b.PeriodOrder).map((item) => ({ ...item, label: item.PeriodName, value: item.PeriodName, selected:false }))
        respNew[0].selected = true
        setSelectedObject(respNew.find((item) => item.value === selectedObject) || respNew[0]?.PeriodName || '') 
        setProgressionDropdownData(respNew)
        setPageData(decode(respNew[0]?.PeriodRecommendationElement))
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
  }

  const RecommendationsEditButton = () => {
    return (
      <>
        {ROLES_MM_PRIMARY.includes(user?.UserType) && !loading && !projectIdValue?.IsFreezed && (
          <ReportEditRecommendations
            InsightsElementId={props.InsightsElementId}
            pageData={pageData || ''}
            onSuccess={onSuccessEdit}
            title={props.Title}
          />
        )}
      </>
    )
  }

  const generatePptObjectFunc = async (param) => {
    if (isPPTModalActive && !loading) {
      const hasTable = document.getElementById(props.type)?.querySelector('table')
      const key = props.InsightsElementType + '__' + props.InsightsElementId.replaceAll('-', '_')
      if (!exportToPptObject?.[key]) {
        const id2 = document.getElementById(props.type)?.querySelector('ul')?.children
        if (id2) {
            // remove all <strong> tags under the UL container (unwrap while preserving children)
            try {
              const ulEl = document.getElementById(props.type)?.querySelector('ul');
              if (ulEl) {
                const strongs = Array.from(ulEl.querySelectorAll('strong'));
                strongs.forEach((s) => {
                  const parent = s.parentNode;
                  if (!parent) return;
                  const frag = document.createDocumentFragment();
                  while (s.firstChild) frag.appendChild(s.firstChild);
                  parent.replaceChild(frag, s);
                });
              }
            } catch (err) {
              console.warn('Failed to remove <strong> tags in recommendations UL:', err);
            }

          const finalResultArray = []
          const pptFunc = (index) => {
            if (index < id2.length) {
              const json = convertHtmlToPptJson(id2[index], {
                bulletList: ['none', '25BA', '25CC', '25AA', '25CC'],
                componentType: 'recommendation',
                downlaodType: 'ppt',
                hasTable: hasTable,
              })
              json.then(function (resultArray) {
                const tableCheck = Array.isArray(resultArray?.[1])
                  ? resultArray?.[1]?.filter((e) => e?.type === 'TR' && e?.parentType === 'TBODY')
                  : []
                if (tableCheck?.length > 0) {
                  finalResultArray.push(resultArray)
                  pptFunc(index + 1)
                } else {
                  let checkNewLine = []
                  for (let i = 0; i < resultArray.length; i++) {
                    if (resultArray[i].type === 'HR') {
                      finalResultArray.push(checkNewLine)
                      checkNewLine = [checkNewLine[0]]
                    } else {
                      checkNewLine.push(resultArray[i])
                    }
                  }
                  finalResultArray.push(checkNewLine)
                  pptFunc(index + 1)
                }
              })
            } else {
              const obj = { [key]: finalResultArray }
              updatingExportToPptObject(obj)
              setTimeout(updateSubLhsApiLoaded(props), 2000)
            }
          }
          pptFunc(0)
        }
      }
    }
  }
  const generateDocObjectFunc = async () => {
    const id2 = document.getElementById(props.type)?.querySelector('ul')?.children
    if (id2) {
      const finalResultArray = []
      const pptFunc = (index) => {
        if (index < id2.length) {
          const json = convertHtmlToPptJson(id2[index], {
            bulletList: ['none', '25BA', '25CC', '25AA', '25CC'],
            componentType: 'recommendation',
            downlaodType: 'doc',
          })
          json.then(function (resultArray) {
            finalResultArray.push(resultArray)
            pptFunc(index + 1)
          })
        } else {
          setDocArrayData(finalResultArray)
        }
      }
      pptFunc(0)
    }
    
    const hasTable = document.getElementById(props.type)?.querySelector('table')
    setHasTables(hasTable)
  }

  useEffect(() => {
    if (!pageData) {
      loadReportRecommendations()
      loadReportProlgressionDropdown()
    }
  }, [])

  useEffect(() => {
    if (pageData?.length) {
      htmlToJson(pageData)
      // removingTags(pageData)
    }
    setTimeout(() => {
      // if(document.getElementById(props.type)){
      //     // REMOVING TABLES IN RECOMMENDATION, WHEN EXPORTED TO PPT ..
      //     const table = document.getElementById(props.type).querySelectorAll('table')
      //     for (let i=0; i< table.length; i++) {
      //         table[i].outerHTML = '<div><br/></div>'
      //     }
      // }
      generateDocObjectFunc()
    }, 500)
  }, [pageData])

  useEffect(() => {
    if (document.getElementById(props.type)) {
      // REMOVING TABLES IN RECOMMENDATION, WHEN EXPORTED TO PPT ..
      // const table = document.getElementById(props.type).querySelectorAll('table')
      // for (let i=0; i< table.length; i++) {
      //     table[i].outerHTML = '<div><br/></div>'
      // }
      const hasTable = document.getElementById(props.type)?.querySelector('table')
      generatePptObjectFunc({ hasTable: hasTable })
    }
  }, [isPPTModalActive && loading])

  /*
    const onSuccessFunc = (resp) => {
        const respNew = Array.isArray(resp) ? resp[0] : resp
        const decodedData = decode((respNew))
        setPageData(decodedData)
        setTimeout(() => {
            if(document.getElementById(props.type)){
                htmlToJson(decodedData)
            } else {
                setTimeout(() => { htmlToJson(decodedData) }, 2000)
            }
            removingTags(decodedData)
            generatePptObjectFunc()
        }, 2000)
    }

    useEffect(() => {
        if(isSuccess && data?.length) onSuccessFunc(data)
    }, [isSuccess, data])
  */

  const progressionDropdownChangeFunc = (obj) => {
    setSelectedObject(obj.selectedObj)
    setPageData(decode(obj.selectedObj.PeriodRecommendationElement))
  }

  return (
    <>
      <ReportHeading
        downloadId={props.type}
        downloadIdData={htmlToJsonData}
        wordDocData={!hasTables ? docArrayData : null}
        subHeading=''
        {...props}
        progressionDropdownData={progressionDropdownData}
        progressionDropdownEvents={progressionDropdownChangeFunc}
        additionalMiddleButton={<RecommendationsEditButton />}
        addTable={false}
      />
      <ReportOuterWrapper>
        <OuterWrapper>
          {/* <LoaderWrapper loadOnlyApi={props.loadOnlyApi} isLoading={isLoading} isSuccess={isSuccess} isError={isError} error={error}> */}
          <LoaderWrapper loadOnlyApi={props.loadOnlyApi} loading={loading}>
            <InnerWrapper id={props.type}>
              <ContentWrapper
                dangerouslySetInnerHTML={{ __html: pageData }}
                // isLocalUser={ROLES_MM_PRIMARY.includes(user?.UserType)}
              />
            </InnerWrapper>
          </LoaderWrapper>
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportRecommendations
